import request from '@/utils/request'

// 查询租赁合同+代扣合同 (https://mock-test.cheweijia.com/project/10282/interface/api/491863)
export function queryContractDetail(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract2/queryContract',
    method: 'POST',
    data,
  })
}

// 租赁合同+代扣合同预览 (https://mock-test.cheweijia.com/project/10282/interface/api/491869)
export function getContractPreview(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract2/preview',
    method: 'POST',
    data,
  })
}

// 框架协议到期提醒接口
export function checkWithholdContractDate(data = {}) {
  return request({
    url: '/admin/v1/vehicle/contract2/checkWithholdContractDateByOrderId',
    method: 'POST',
    data,
  })
}


export function alipayWithholdPreivew(data = {}) {
  return request({
    url: '/admin/v1/vehicle/alipay/withhold/preview',
    method: 'POST',
    data,
  })
}


export function alipayWithholdStartSign(data = {}) {
  return request({
    url: '/admin/v1/vehicle/alipay/withhold/startSign',
    method: 'POST',
    data,
    bizCode: [13997],
  })
}
